module.exports = __webpack_public_path__ + "media/site_templates/www.cheapgardenservices.com.au/images/testimonials-5e7b7f45a47d027a1b52d56ae69274f0.jpg";